// admin/packages/admin/src/utils/scrapingApi.ts
// Appels vers VITE_BACKEND_URL (port 3001 — backend admin/TikTok)

import {
  Retailer,
  ScrapingRun,
  ScrapingRunItemResult,
  SingleIngredientScrapeResponse,
} from '../types/retailerProduct';
import { normalizeBackendUrl } from './backendUrl';

const BACKEND_URL = normalizeBackendUrl(import.meta.env.VITE_BACKEND_URL);

async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${BACKEND_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', ...init.headers },
    ...init,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = (payload as any)?.error || `Request failed (${response.status})`;
    const err = new Error(message) as Error & { status?: number };
    err.status = response.status;
    throw err;
  }
  return payload as T;
}

/** Scrape un seul ingrédient (synchrone, résultat immédiat). */
export function scrapeIngredient(
  ingredientId: string,
  retailer: Retailer = 'carrefour'
): Promise<SingleIngredientScrapeResponse> {
  return apiFetch<SingleIngredientScrapeResponse>(
    `/api/scraping/ingredient/${encodeURIComponent(ingredientId)}`,
    { method: 'POST', body: JSON.stringify({ retailer }) }
  );
}

/** Crée un nouveau run de scraping global. */
export function createScrapingRun(params: {
  retailer: Retailer;
  scope: 'all' | 'limit' | 'specific';
  scopeLimit?: number;
  scopeIngredientIds?: string[];
}): Promise<{ runId: string }> {
  return apiFetch<{ runId: string }>('/api/scraping/runs', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/** Récupère l'état d'un run. */
export function getScrapingRun(runId: string): Promise<ScrapingRun> {
  return apiFetch<ScrapingRun>(`/api/scraping/runs/${encodeURIComponent(runId)}`);
}

/** Récupère le détail des items d'un run. */
export function getScrapingRunItems(runId: string): Promise<ScrapingRunItemResult[]> {
  return apiFetch<ScrapingRunItemResult[]>(
    `/api/scraping/runs/${encodeURIComponent(runId)}/items`
  );
}

/** Récupère l'historique des runs (les 20 derniers). */
export function listScrapingRuns(retailer?: Retailer): Promise<ScrapingRun[]> {
  const qs = retailer ? `?retailer=${retailer}` : '';
  return apiFetch<ScrapingRun[]>(`/api/scraping/runs${qs}`);
}
